export function useShowMe() {
  const handleShowMe = (context) => {
    if (["/", "/settings", "/plans"].includes(location.pathname)) {
      if (context.currentBranch) {
        if (context.currentBranch.branch_plan) {
            const branchPlan = context.currentBranch.branch_plan
            return branchPlan.id !== "b85046a1-3803-4ee4-a858-8ef2c26d9d76"
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  };
  return handleShowMe;
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Plans/BuyAdditionalNotes/hooks/index.js